import React from 'react';
import { connect } from 'react-redux';
// import {addFlashMessage} from '../actions/flashMessages';
import PropTypes from 'prop-types';
import { withAlert } from 'react-alert';
import { bindActionCreators } from 'redux';

import {
  clearSignupData,
} from '../Actions/actions';


export default function (ComposedComponent) {
  class AuthenticateOnLogin extends React.Component {
    componentDidMount() {
      const AuthInfo = localStorage.getItem('user');
      const roleName = localStorage.getItem('roleName');
      const loginStatus = localStorage.getItem('loginStatus');
      if (roleName === 'Consumer' || roleName === 'Business-User') {
        if (loginStatus === 'error') {
          this.context.router.history.push('/profile-terms');
        } else {
          if (localStorage.getItem("paymentStatus") === "pending"
              && !!localStorage.getItem("paymentFailedButLetUserIn") === false) {
            this.context.router.history.push('/add-payment-method');
          } else {
            this.context.router.history.push('/dashboard');
          }
        }
      } else {
        if (AuthInfo !== null && (roleName === 'Affiliate' || roleName === 'Affiliate-SubUser')) {
          this.context.router.history.push('/affiliate');
        }
        if (AuthInfo !== null && (roleName !== 'Consumer' || roleName !== 'Business-User')) {
          if (localStorage.getItem("paymentStatus") === "pending"
              && !!localStorage.getItem("paymentFailedButLetUserIn") === false) {
            this.context.router.history.push('/add-payment-method');
          } else {
            this.context.router.history.push('/dashboard');
          }
        }
      }
      // const { location: { pathname } } = this.props;

      // if (pathname !== '/signup-step1' && pathname !== '/signup' && pathname !== '/signup-plan-page' && pathname !== '/signup-terms-condition' && pathname !== '/signup-signature-page') {
      //   localStorage.removeItem('persist:root');
      //   this.props.clearSignupData();
      // }
    }

    render() {
      return (
        <ComposedComponent {...this.props} />

      );
    }
  }
  AuthenticateOnLogin.propsTypes = {
    // isAuthenticated: PropTypes.bool.isRequired,
    // addFlashMessage: PropTypes.func.isRequired
  };
  AuthenticateOnLogin.contextTypes = {
    router: PropTypes.object.isRequired,
  };

  function mapStateToProps() {
    return {
      //  isAuthenticated: state.auth.isAuthenticated
    };
  }

  const mapDispatchToProps = dispatch =>
    bindActionCreators({
      clearSignupData,
    }, dispatch);

  return withAlert(connect(mapStateToProps, mapDispatchToProps)(AuthenticateOnLogin));
}
